import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const activeLanguage = i18n.language;
  const lang = i18n.language;

  useEffect(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, []);

  return (
    <div className="overflow-hidden w-full bg-bggradient justify-center items-center lg:h-[83vh] relative">
      <img
        src="\Images\bgvector.png"
        alt=""
        className="absolute bottom-0 z-0 opacity-5"
      />
      <div className="w-[90%] flex h-full gap-10 lg:flex-row mx-auto z-10 flex-col lg:items-center py-10">
        <div className={`${activeLanguage === "en" ? 'order-2' : 'order-0'} w-full lg:w-[35%]`}>
          <img
            src="/Images/herolawer.png"
            alt="lawerPhoto"
            className="object-contain w-full h-auto"
          />
        </div>

        <div className={`text-section flex flex-col gap-6 lg:w-[60%] ${lang === 'ar' ? 'text-right' : 'text-left'}`}>
          <h3 className="text-[#003E6F] text-lg font-medium">
            {/* يمكن إضافة عنوان فرعي هنا إذا لزم */}
          </h3>
          <h1 className="text-[#003E6F] text-3xl lg:text-5xl font-black leading-snug">
            {t('homeTitle') || 'فواز الداهـش للمحاماة'}
          </h1>
          <p className="text-[#000] text-lg leading-9">
            {t('homeDetails') || 'شركة مرخصة لمزاولة مهنة المحاماة من وزارة العدل في المملكة العربية السعودية حيث تقدم الشركة خدمات قانونية في مختلف مجالات القانون'}
          </p>
          <div className={`flex gap-3 relative z-[50] mt-4 ${lang === 'ar' ? 'justify-end' : 'justify-start'}`}>
            <Link
              to="/contacts"
              className="bg-[#003E6F] text-white px-6 py-2 rounded-md font-medium hover:bg-[#00264d] transition"
            >
              {t('homeConnectWithUsButton') || 'تواصل معنا'}
            </Link>

            <Link
              to="/services"
              className="border border-[#003E6F] text-[#003E6F] px-6 py-2 rounded-md font-medium hover:bg-[#e6f0fa] transition"
            >
              {t('homeLearnMoreButton') || 'تعرف على خدماتنا'}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
